<template>
  <div class="apply-add-form">
    <b-overlay
      :show="!formatData"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <my-form
        v-if="formatData"
        ref="overFormRef"
        :data="formatData"
        :loading="loading"
        :option="option"
        width="auto"
        :footer-visible="false"
        @submit="handleSubmit"
      />
      <div class="apply-add-form-line" />
      <time-line :data="formatHistoryData" />
      <b-img
        v-if="processInstanceId"
        :src="`/api/blade-flow/process/diagram-view?processInstanceId=${processInstanceId}&processDefinitionId=&?time=${new Date().getTime()}`"
      />
    </b-overlay>

    <slot name="audit" />
  </div>
</template>

<script>
// import MyForm from '@/components/myForm/index.vue';
import { workerDetail } from '@/api/worker/turnSite'
import applyAPI from '@/api/apply/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import templateFormAPI from '@/api/templateForm/index'
import TimeLine from '@/components/timeLine.vue'
import {
  BRow, BCol, BImg, BOverlay,
} from 'bootstrap-vue'
import { templateFormat } from '@/util/func'

export default {
  name: 'ApplyAddForm',
  components: {
    MyForm: () => import('@/components/myForm/index.vue'),
    TimeLine,
    BImg,
    BOverlay,
  },
  props: {
    processId: {
      type: [Number, String],
      default: undefined,
    },
    formId: {
      type: [Number, String],
      default: undefined,
    },
    id: {
      type: [Number, String],
      default: undefined,
    },
    processKey: {
      type: String,
      default: undefined,
    },
    processInstanceId: {
      type: String,
      default: undefined,
    },
    data: {
      type: Object,
      default: undefined,
    },
    defaultColumns: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      form: {
        isPass: false,
      },
      loading: false,
      columns: [],
      historyData: [],
    }
  },
  computed: {
    option() {
      const option = {
        columns: this.columns,
      }
      return option
    },
    formatData() {
      const { data } = this
      return data || undefined
    },
    formatHistoryData() {
      const res = []
      const temp = this.historyData
      temp.sort((a, b) => {
        if (!b.endTime) {
          return -1
        }
        if (!a.endTime) {
          return 1
        }
        return (b.endTime > a.endTime ? -1 : 1)
      })
      temp.forEach((item, i) => {
        let title = ''
        let variant = 'primary'
        if (i === 0) {
          title = 'OA CREATE'
        } else if (i === this.historyData.length - 1 && !item.historyActivityName && this.historyData.length > 2) {
          title = 'OA END'
        } else {
          title = `${item.historyActivityName}`
        }
        const tip = `Start Time ${item.createTime} - End Time ${item.endTime}`
        const info = `${item.assigneeName}`
        const remark = `Remarks: ${item.comment}`
        if (i === this.historyData.length - 1) {
          if (title !== 'OA END') {
            variant = 'secondary'
          }
        }
        res.push(
          {
            title,
            tip,
            info,
            remark,
            variant,
          },
        )
      })
      return res
    },
  },
  watch: {
    processInstanceId: {
      handler(e) {
        if (e) {
          applyAPI.history({ processInstanceId: e }).then(res => {
            this.historyData = res.data.data
          })
        }
      },
      immediate: true,
    },
    formId: {
      handler(e) {
        if (e) {
          this.onLoad(e)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.processId) {
      this.id = this.processId
      workerDetail({ id: this.processId }).then(res => {
        const { data } = res.data
        this.processKey = data.processKey
        this.processInstanceId = data.processInstanceId
        this.formId = data.formId
        this.data = data.map || {}
      })
    //   applyAPI.detail({ id: this.processId }).then(res => {
    //     const { data } = res.data
    //     this.processKey = data.processKey
    //     this.processInstanceId = data.processInstanceId
    //     this.formId = data.formId
    //     this.data = data.map || {}
    //   })
    }
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    validationForm() {
      console.log(this.form, 'submit');
    },
    toHump(name) {
      // eslint-disable-next-line no-useless-escape
      return name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase());
    },
    resetForm() {
      this.form = {}
    },
    onLoad(formId) {
      // if (this.defaultColumns) {
      //   this.columns = this.defaultColumns
      //   return
      // }
      templateFormAPI.detail({ formId }).then(res => {
        const temp = res.data.data.records
        let tempArr = templateFormat(temp)
        tempArr = tempArr.filter(el => el.field !== 'workerId')
        const resArr = []
        tempArr.forEach(item => {
          const params = item
          params.disabled = true
          resArr.push(params)
        })
        this.columns = resArr
      })
    },
    handleSubmit(form) {
      const params = form
      params.processKey = this.processKey
      params.formId = this.id
      applyAPI.edit(params).then(res => {
        this.$emit('close')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      })
    },
    transformArrayBufferToBase64(buffer) {
      let binary = '';
      const bytes = new Uint8Array(buffer);
      for (let len = bytes.byteLength, i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
  },
}

</script>

<style lang='scss' scoped>
.apply-add-form{
    &-line{
        width: 100%;
        border-bottom: 1px solid #CAD6EB;
    }
}
</style>
